// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import Select2, { DataSelect2 } from 'wdna-select2';

import { AdjustmentDO, SensorListDO } from '../../../requests';
import { TypeSensorVariableListDO } from '../../../../configuration/requests';

interface Props {
  formValues: {
    sensorArray: SensorListDO[];
    typeVariableArray: TypeSensorVariableListDO[];
    data: Partial<AdjustmentDO>;
  };
  onChangeDevice: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onChangeStandard: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement |HTMLSelectElement>) => void;
}

/**
 * Function to generate a form component
 *
 * @param props properties of the component
 * @returns jsx element with the form
 */
export default function Form(props: Props): JSX.Element {
  const { data, typeVariableArray, sensorArray } = props.formValues;

  const isNew: boolean = (data.id == null);

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Device</b> &nbsp;
          </label>
          <Select2
            name="sensor.id"
            disabled={!isNew}
            data={sensorArray.map((item: SensorListDO): DataSelect2 => {
              return { text: `${item.code} | ${item.name}`, id: item.id };
            })}
            value={(data?.sensor?.id || '')}
            options={{
              placeholder: 'Select option',
            }}
            onChange={props.onChangeDevice}
            style={{ width: '80%' }}
          />
          <label>&nbsp;&nbsp;{isNew ? '*' : ''}</label>
        </div>
        <div className="col-6">
          <label className="label">
            <b>Formula</b> - Write DX to use the chosen variable in the formula.
          </label>
          &nbsp;
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.formula || ''}
            name="formula"
            onChange={props.onChangeStandard}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Variable Type</b> &nbsp;
          </label>
          <Select2
            name="typeSensorVariable.id"
            data={typeVariableArray.map((item: TypeSensorVariableListDO): DataSelect2 => {
              return { text: `${item.order}: ${item.variableName}`, id: item.id };
            })}
            value={(data?.typeSensorVariable?.id || '')}
            options={{
              placeholder: 'Select option',
            }}
            onChange={props.onChangeStandard}
            style={{ width: '80%' }}
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Comments</b> - Available characters: {255 - ((data.comments && data.comments.length) || 0)}
          </label>
          <textarea
            className="inputNew"
            style={{ width: '80%' }}
            name="comments"
            id="comments"
            rows={5}
            cols={55}
            maxLength={255}
            value={data.comments || ''}
            onChange={props.onChangeStandard}
          />
        </div>
      </div>
    </fieldset>
  );
}
